import React from "react";
import { cn } from "../../../utils/cn";
import ScheduleGridLegend from "./ScheduleGridLegend";
import CityGrid from "./CityGrid";
import type { AgendaConsultant, AgendaDayPayload } from "../agendaTypes";
import type { CityWeather } from "../agendaWeatherTypes";
import { AGENDA_FEATURE_FLAGS } from "../constants/agendaFeatureFlags";

type AgendaScheduleCardProps = {
  className?: string;
  dateIso: string;
  dayData: AgendaDayPayload;
  consultants: AgendaConsultant[];
  cityWeatherByName?: Map<string, CityWeather>;
  weatherCities?: CityWeather[];
  weatherPreferredCity?: string | null;
  weatherCommercialRegionId?: number | null;
  hourRainByCity?: Map<string, Map<string, number>>;
  weatherLoading?: boolean;
  weatherFailed?: boolean;
  weatherAttribution?: string | null;
  highlightedScheduleIds?: Set<number>;
  canManageSchedules: boolean;
  initialStatus: number | undefined;
  dateSelected: string[];
  onSelectCell: (
    scheduleOption: { id: number; date: string; status: number },
    event: React.MouseEvent
  ) => void;
  onSelectCellMouseOver: (coord: string, event: React.MouseEvent) => void;
  onOpenVisitDetails: (coord: string) => void;
  detailPanelOpen?: boolean;
  showLegend?: boolean;
  legendPlacement?: "top" | "bottom";
};

const AgendaScheduleCard: React.FC<AgendaScheduleCardProps> = ({
  className,
  weatherAttribution,
  detailPanelOpen,
  showLegend = true,
  legendPlacement = "top",
  ...gridProps
}) => (
  <section
    className={cn(
      "overflow-hidden rounded-xl border border-[#E2E8F0] bg-[#F7FAFC]",
      className
    )}
  >
    {showLegend ? <ScheduleGridLegend placement={legendPlacement} /> : null}
    <div className="border-t border-[#EDF2F7]/80 px-3 pb-3 pt-3.5">
      <CityGrid {...gridProps} detailPanelOpen={detailPanelOpen} />
    </div>
    {AGENDA_FEATURE_FLAGS.weatherRow && weatherAttribution ? (
      <p className="border-t border-[#EDF2F7]/80 px-3 py-2 text-[11px] text-[#A0AEC0]">
        {weatherAttribution}
      </p>
    ) : null}
  </section>
);

export default AgendaScheduleCard;
